/*! @azure/msal-common v8.0.0 2022-11-07 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Authority types supported by MSAL.
 */
var AuthorityType;
(function (AuthorityType) {
    AuthorityType[AuthorityType["Default"] = 0] = "Default";
    AuthorityType[AuthorityType["Adfs"] = 1] = "Adfs";
    AuthorityType[AuthorityType["Dsts"] = 2] = "Dsts";
})(AuthorityType || (AuthorityType = {}));

export { AuthorityType };
//# sourceMappingURL=AuthorityType.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@azure/msal-common/dist/authority/AuthorityType.js
// module id = 64
// module chunks = 0